import React from 'react'

const NotFoundPage = () => (
  <div>
    <h1>Page non trouvée</h1>
    <p>Si vous ne retrouvez pas votre chemin, vous pouvez nous contacter</p>
  </div>
)

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js